import { rgba } from "polished";

const colorAccent =
  process.env.REACT_APP_COLOR_ACCENT || process.env.REACT_APP_COLOR_PRIMARY;
const colorAccentText = process.env.REACT_APP_COLOR_ACCENT_TEXT || "#ffffff";
const colorLightGrey = process.env.REACT_APP_COLOR_LIGHT_GREY || "#ecf0f5";
const colorText = process.env.REACT_APP_COLOR_TEXT || "#626a75";
const colorLabel = process.env.REACT_APP_COLOR_LABEL || "#9aa4b1";

export const theme = {
  colorBackground: "#1b458f",
  colorContentBackgroundMobile:
    process.env.REACT_APP_COLOR_CONTENT_BACKGROUND_MOBILE || "transparent",
  colorContentBackground: colorLightGrey,
  colorTicketBackground: "white",
  colorTicketText: colorText,
  colorTicketLabel: colorLabel,
  colorPrimary: "#c8ccd1",
  colorPrimaryText: "white",
  colorAccent: colorAccent,
  colorAccentText: colorAccentText,
  colorDark: "#040404",
  colorDarkText: "white",
  colorCheckboxGrey:
    process.env.REACT_APP_COLOR_CHECKBOX_GREY || colorLightGrey,
  colorCheckboxActiveBackground:
    process.env.REACT_APP_COLOR_CHECKBOX_ACTIVE_BACKGROUND || colorAccent,
  colorCheckboxActiveForeground:
    process.env.REACT_APP_COLOR_CHECKBOX_ACTIVE_FOREGROUND || colorAccentText,
  colorSpinnerAccent: process.env.REACT_APP_COLOR_SPINNER_ACCENT,
  colorSpinnerRail: process.env.REACT_APP_COLOR_SPINNER_RAIL,
  colorText: colorText,
  colorBorder: process.env.REACT_APP_COLOR_BORDER || "#EEF0F3",
  colorLightGrey: colorLightGrey,
  colorBurgerTitleBackground: "#040404",
  colorBurgerTitleText: "white",
  colorSuccess: "#386dc9",
  colorDanger: "#df3636",
  colorLabel: colorLabel,
  colorLabelHover: "#909aa8",
  colorPickemButtonTextActive:
    process.env.REACT_APP_COLOR_PICKEM_BUTTON_TEXT_ACTIVE,
  colorPickemButtonBackgroundActive:
    process.env.REACT_APP_COLOR_PICKEM_BUTTON_BACKGROUND_ACTIVE,
  colorPickemButtonBackground:
    process.env.REACT_APP_COLOR_PICKEM_BUTTON_BACKGROUND || colorLightGrey,
  colorPickemButtonText:
    process.env.REACT_APP_COLOR_PICKEM_BUTTON_TEXT || colorText,
  colorPicksBannerBackground:
    process.env.REACT_APP_COLOR_PICKS_BANNER_BACKGROUND,
  colorPicksBannerForeground:
    process.env.REACT_APP_COLOR_PICKS_BANNER_FOREGROUND,
  colorPicksBannerText: process.env.REACT_APP_COLOR_PICKS_BANNER_TEXT,
  colorPicksBannerLabel: process.env.REACT_APP_COLOR_PICKS_BANNER_LABEL,
  colorCardBackground: process.env.REACT_APP_COLOR_CARD_BACKGROUND || "#ffffff",
  colorDisabledBackground:
    process.env.REACT_APP_COLOR_DISABLED_BACKGROUND || "#c8ccd1",
  colorDisabledText: process.env.REACT_APP_COLOR_DISABLED_TEXT || "#a4acb6",
  colorLeaderboardBackground:
    process.env.REACT_APP_COLOR_LEADERBOARD_BACKGROUND || "red",
  colorSkeleton: process.env.REACT_APP_COLOR_SKELETON || "#eceef1",
  colorLeaderboardButtonBackground:
    process.env.REACT_APP_COLOR_LEADERBOARD_BUTTON_BACKGROUND || "white",
  colorLeaderboardButtonText:
    process.env.REACT_APP_COLOR_LEADERBOARD_BUTTON_TEXT || colorText,
  colorLeaderboardPrizeBackground:
    process.env.REACT_APP_COLOR_LEADERBOARD_PRIZE_BACKGROUND || "white",
  colorLeaderboardPrizeText:
    process.env.REACT_APP_COLOR_LEADERBOARD_PRIZE_TEXT || colorText,
  colorSkeletonShimmer:
    process.env.REACT_APP_COLOR_SKELETON_SHIMMER || "#e4e7ea",
  colorSpinnerBackground: "rgba(0, 0, 0, 0.1)",
  colorSpinnerBackgroundForDark: "rgba(255, 255, 255, 0.175)",
  colorAlertSuccessText:
    process.env.REACT_APP_COLOR_ALERT_SUCCESS_TEXT || "#23ad6d",
  colorAlertSuccessBackground:
    process.env.REACT_APP_COLOR_ALERT_SUCCESS_BACKGROUND || "#e1f1e6",
  colorAlertDefaultText:
    process.env.REACT_APP_COLOR_ALERT_DEFAULT_TEXT || "#416ebb",
  colorAlertDefaultBackground:
    process.env.REACT_APP_COLOR_ALERT_DEFAULT_BACKGROUND || "#e9effb",
  colorAlertDangerText:
    process.env.REACT_APP_COLOR_ALERT_DANGER_TEXT || "#f35959",
  colorAlertDangerBackground:
    process.env.REACT_APP_COLOR_ALERT_DANGER_BACKGROUND || "#ffe7e7",
  colorNavbarLink: process.env.REACT_APP_COLOR_NAVBAR_LINK || colorLabel,
  colorNavbarBackground:
    process.env.REACT_APP_COLOR_NAVBAR_BACKGROUND || "#ffffff",
  colorNavbarLinkDisabled: process.env.REACT_APP_COLOR_NAVBAR_LINK_DISABLED,
  colorNavbarLinkActive:
    process.env.REACT_APP_COLOR_NAVBAR_LINK_ACTIVE ||
    process.env.REACT_APP_COLOR_PRIMARY,
  colorEmptyScreenBackground: "transparent",
  colorEmptyScreenText: rgba("white", 0.96),
  colorEmptyScreenLabel: rgba("white", 0.67),
  colorBetbarBackground:
    process.env.REACT_APP_COLOR_BETBAR_BACKGROUND || "#ffffff",
  colorBetbarBackgroundLeaderboard:
    process.env.REACT_APP_COLOR_BETBAR_BACKGROUND_LEADERBOARD ||
    "rgba(255, 255, 255, 0.1)",
  colorPicksBannerBackground:
    process.env.REACT_APP_COLOR_PICKS_BANNER_BACKGROUND ||
    "rgba(255, 255, 255, 0.12)",
  fontFamily: "Poppins",
  screenWidthXxs: "360px",
  screenWidthXs: "576px",
  screenWidthSm: "768px",
  screenWidthMd: "992px",
  screenWidthLg: "1200px",
  screenWidthXl: "1920px",
  screenWidthXxl: "2400px",
  railWidth: "500px",
  borderRadius: "2px",
  floatingBarHeight: 80,
  topbarHeight: process.env.REACT_APP_HIDE_TOPBAR !== "true" ? 56 : 0,
  inputBackground: process.env.REACT_APP_COLOR_INPUT_BACKGROUND || "#EEF0F3",
  inputFontStyle: "normal",
  inputBorderStyle: "full",
  inputBorderRadius: "2px",
  inputFontSize: "1rem",
  inputFontWeight: "600",
  inputFontFamily: "Poppins",
  buttonUppercase: false,
  boxShadowCard: "none",
  boxShadowNavbar: "-10px 0 30px rgba(0,0,0,0.05)",
  zIndexSlideUpDialog: 10,
  zIndexFloatingHeader: 11,
  colorShareButton: "#5bbe4a"
};
